import React, { useEffect } from "react";
import { AllUsers } from "@hedgefund/shared";
import { getAllUsers } from "../CreateNewUser/actions";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";

const UserManagement = () => {
  const createUserState = useSelector((state) => state.createNewUsers);
  const history = useHistory();
  const dispatch = useDispatch();
  const { loading, users } = createUserState;

  useEffect(() => {
    dispatch(getAllUsers());
  }, [dispatch]);

  const onClickEdit = (id) => {
    history.push(`/user/${id}`);
  };

  const onClickCreateUser = () => {
    history.push("/create");
  };

  return (
    <AllUsers
      onClickEdit={onClickEdit}
      data={users?.items}
      loading={loading}
      onClickCreateUser={onClickCreateUser}
    />
  );
};

export default UserManagement;
